import { useNavigate, useParams } from 'react-router-dom';
export const LimitHostModal = ({ showLimitModal }: any) => {
  if (!showLimitModal) return null;
  const navigate = useNavigate();
  const { id } = useParams<string>();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-100">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-center mb-4">
          <div className="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center mr-4">
            <svg
              className="w-6 h-6 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900">This Studio is full</h3>
        </div>

        <p className="text-gray-600 mb-6 leading-relaxed">
          You will be able to join after someone leaves.
        </p>

        <div className="flex gap-3 justify-end">
          <button
            onClick={() => {
              navigate(`/videos/${id}`);
            }}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300 transition-colors">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
